import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    name: 'root',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [], // 插件路由动态注入到这里
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/Login.vue'),
    meta: { public: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 全局守卫
router.beforeEach(async (to) => {
  const auth = useAuthStore();

  // 未登录：仅允许访问 /login，其余一律跳登录。
  // 注意：不能在这里用 to.meta.public 放行——因为插件路由是动态注册的，
  // 刷新 /pve-mgr 时该路径尚未注册，会命中 not-found 兜底（其 meta.public=true），
  // 导致直接放行、跳过 loadPlugins，页面渲染成 Login.vue（表现为刷新跳登录页）。
  if (!auth.token) {
    return to.path === '/login' ? true : { path: '/login' };
  }

  // 已登录：首次访问需加载插件清单并动态注册路由
  if (!auth.pluginsLoaded) {
    await auth.loadPlugins(router);
    // 插件路由是 addRoute 动态注入的，当前导航在导航开始时已用旧路由表
    // 解析过 to，addRoute 不会让当前导航重新匹配。返回当前路径强制重新
    // 触发一次导航，让 to 按新路由表重新解析。
    return { path: to.fullPath, replace: true };
  }

  // 默认进入平台总览，避免根路径内容区空白
  if (to.path === '/') {
    return { path: '/dashboard', replace: true };
  }

  return true;
});

export default router;
